
import React from 'react';
import SectionTitleBar from '../components/titlebar';
import { BaseReact } from '../../base.model';

import './Dashboard.scss';
import { ProfileQL } from '../../models/Profile';
import { ToBillArguments, ToBillEvent } from '../../models/Factura';

import { clearGqlTypename } from '../../utils/formatting';

import DashboardBillEventList from './Dashboard.billEventList';
import DashboardSummary from './Dashboard.summary';

interface DashboardProps extends BaseReact {
    currentUser: ProfileQL;
}

function Dashboard({ history, location, currentUser }: DashboardProps) {
    const goToEmitBillEvent = (billEvent: ToBillEvent, parentArgument: ToBillArguments<ToBillEvent>) => {
        history.push({
            pathname: '/facturacion/facturar/preview/billevent',
            state: { billArgument: parentArgument, billEvents: [billEvent] }
        })
    }

    const goToEmitPago = (billEvent: ToBillEvent, parentArgument: ToBillArguments<ToBillEvent>) => {
        history.push({
            pathname: '/facturacion/setup/pagos',
            state: { billArgument: clearGqlTypename(parentArgument), paymentEvents: [clearGqlTypename(billEvent)] }
        })
    }

    return (
        <div id="Dashboard">
            <SectionTitleBar currentUser={currentUser} title="Resumen de Facturación" />
            <div className="dashboardContent">
                <div className="summaryActivity">
                    <DashboardSummary currentUser={currentUser} />
                </div>

                <div className={`tableDashboard`}>
                    <div className="_bills">
                        <h4>Facturas o complementos de pago pendientes</h4>
                        <DashboardBillEventList
                            onEmitBillEvent={goToEmitBillEvent}
                            onEmitPago={goToEmitPago}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dashboard;
